/**
 * Supporting a group is answered two ways — for the one group, and for every
 * group of the design — so a write to one refreshes both.
 */
export default function invalidateSupporterQueries(queries, designId, groupId) {
  queries.invalidateQueries(`v1/designs/${designId}/supporters`);
  queries.invalidateQueries(
    `v1/designs/${designId}/groups/${groupId}/supporters`
  );
}
